export default __webpack_public_path__ + "static/media/freeeducation.8baa9c88.jpg";